<label class="checkbox"
	>Remember Me
	<input type="checkbox" (click)="rememberMeToggle()" />
	<span class="checkmark"></span>
</label>
